export const VERSION = 'v1.0'


// WEBPACK FOOTER //
// ./src/apis/config.js